import React from 'react';
import { LanguageProvider } from './LanguageContext';
import { ThemeProvider } from './ThemeContext';
import { DataProvider, useData } from './DataContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

const ErrorBanner = () => {
  const { apiError, dismissError } = useData();
  if (!apiError) return null;
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] max-w-md w-full mx-4 px-4 py-3 bg-yellow-500/90 text-black text-sm rounded-xl shadow-lg flex items-center justify-between gap-3">
      <span>{apiError}</span>
      <button onClick={dismissError} className="font-bold text-lg leading-none hover:opacity-70">&times;</button>
    </div>
  );
};

function App() {
  // Admin panel redirect (Ctrl+Shift+A)
  React.useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'A') {
        window.location.href = '/admin';
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  return (
    <ThemeProvider>
      <LanguageProvider>
        <DataProvider>
          <ErrorBanner />
          <div className="App min-h-screen">
            <Header />
            <main>
              <Hero />
              <About />
              <Projects />
              <Contact />
            </main>
            <Footer />
          </div>
        </DataProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
